module.exports = __webpack_public_path__ + "static/img/main-banner2.11f5579.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main-banner2.jpg
// module id = ktTZ
// module chunks = 2